import { Activity, useCallback, useRef } from 'react'
import styles from './burgerBtn.module.css'
import MenuIcon from '../../../assets/icons/menuIcon.svg?react'
import { NavigationPanel } from '../../navigationPanel/navigationPanel'
import navPanelStyles from '../../navigationPanel/navigationPanel.module.css'
import { useNavigationPanel } from '../../../hooks/context/useNavigationPanel'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import { useCloseOnInteractions } from '../../../hooks/useCloseOnInteractions'
import { useOverlay } from '../../../hooks/useOverlay'

export function BurgerBtn() {
  const { isOpen, toggle, close } = useNavigationPanel()
  const isWide = useMediaQuery('(min-width: 620px)')
  const triggerRef = useRef<HTMLButtonElement>(null)

  const isMobileView = !isWide
  const { shouldRenderOverlay, overlayState } = useOverlay({
    isOpen,
    isMobile: isMobileView,
    animationDuration: 280,
  })

  const shouldIgnorePointer = useCallback(
    (event: PointerEvent) => triggerRef.current?.contains(event.target as Node) ?? false,
    []
  )

  const wrapperRef = useCloseOnInteractions<HTMLDivElement>({
    isActive: isOpen && isMobileView,
    onClose: close,
    shouldIgnoreEvent: shouldIgnorePointer,
  })

  return (
    <div className={styles.navigationWrapper}>
      <button
        type="button"
        className={styles.burgerButton}
        ref={triggerRef}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
        aria-label="Toggle navigation panel"
        onClick={toggle}
      >
        <MenuIcon />
      </button>

      <Activity mode={shouldRenderOverlay ? 'visible' : 'hidden'}>
        <div
          className={navPanelStyles.mobileBackdrop}
          data-state={overlayState}
          role="presentation"
          onClick={close}
        />
        <div className={navPanelStyles.mobileOverlay} data-state={overlayState}>
          <div
            className={navPanelStyles.mobileOverlayPanel}
            data-state={overlayState}
            ref={wrapperRef}
            role="dialog"
            aria-modal="true"
            aria-label="Navigation menu"
          >
            <NavigationPanel />
          </div>
        </div>
      </Activity>
    </div>
  )
}
